import React, { useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { Price } from "../data/pricing";
import PaymentType from "./PaymentType";
import { Formik } from "formik";
import { EPaymentMethod, useLandingPageContext } from "pages/Context/LandinPageContext";
import CardConfirmPayment from "./CardConfirmPayment";
import { creditCardSchema, pixAndTicketSchema } from "../validations/paymentSchema";

export interface PaymentData {
  cardHolder: string;
  cardNumber: string;
  expiryMonth: string;
  expiryYear: string;
  cvv: string;
  paymentMethod: string;
}

interface PaymentProps {
  pricing: Price[];
  selectedPriceId: number | null;
  handleSelectPrice: (id: number) => void;
  displayedItems: Price[];
  handlePrev: () => void;
  handleNext: () => void;
  startIndex: number;
  itemsToShow: number;
  selectedPrice: Price | undefined;
  ref: React.RefObject<HTMLDivElement>;
}

const Payment: React.FC<PaymentProps> = ({ ref }) => {
  const formikRef = useRef<any>(null);
  const { creditCardContext, paymentMethodContext, pixAndTicketContext } = useLandingPageContext();

  const validation = {
    [EPaymentMethod.CREDIT_CARD]: creditCardSchema,
    [EPaymentMethod.PIX]: pixAndTicketSchema,
    [EPaymentMethod.BOLETO]: pixAndTicketSchema,
  }[paymentMethodContext];

  const initialValues = {
    [EPaymentMethod.CREDIT_CARD]: creditCardContext,
    [EPaymentMethod.PIX]: pixAndTicketContext,
    [EPaymentMethod.BOLETO]: pixAndTicketContext,
  }[paymentMethodContext];
    
  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      validationSchema={validation}
      enableReinitialize
      onSubmit={() => {}}
    >
      {() => (
        <Row className="m-0 p-0">
          <Col xl={9} lg={12} md={12} sm={12} className="mb-4">
            <PaymentType/>
          </Col>
          <Col
            xl={3}
            lg={12}
            md={12}
            sm={12}
            ref={ref}
            className="mb-5 mt-lg-0"
            style={{ minWidth: "256px" }}
          >
            <div className="h-100">
              <CardConfirmPayment/>
            </div>
          </Col>
        </Row>
      )}
    </Formik>
  );
};

export default Payment;
